/**
 * Node.js Polyfills for Browser
 * Required by @react-pdf/renderer and other packages
 */

import { Buffer } from 'buffer';

// Polyfill Buffer for browser
window.Buffer = Buffer;

// Polyfill global for browser
if (typeof window.global === 'undefined') {
  window.global = window as any;
}

// Polyfill process.env
if (typeof window.process === 'undefined') {
  window.process = {} as any;
}

if (typeof window.process.env === 'undefined') {
  window.process.env = {} as any;
}
